// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorPage_root__3QCFg","title":"ErrorPage_title__2_JUy","description":"ErrorPage_description__1_H5K"};